/**
 * Duration (ms) of the content viewer column transition triggered by the
 * CSSTransition for medical chronology and medical billing summary in app viewers.
 */
export const CONTENT_VIEWER_COLUMN_TRANSITION_DURATION_MS = 200
